
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'video.js/dist/video-js.css';
import 'tailwindcss/tailwind.css';
import '#styles/global/ep-app.css';
import '#styles/global/index.scss';
import dynamic from 'next/dynamic';
import ApplicationProviders from '#providers/ApplicationProviders';
import { useDatadogRum, useNewPlayer } from '#hooks';
import Error from './500';
import Head from 'next/head';
import { APOLLO_STATE_PROP_NAME } from '#providers/apollo/addApolloState';

const MediaPlayer = dynamic(() => import('#modules/player/MediaPlayer'), {
  ssr: false,
});

const MediaPlayer2 = dynamic(() => import('#modules/player/MediaPlayer.v2'), {
  ssr: false,
});

const PageHeader = dynamic(() => import('#components/pageheader/PageHeader'), {
  ssr: false,
});

const AnnouncementBar = dynamic(
  () => import('#components/announcement-bar/AnnouncementBar'),
  {
    ssr: false,
  }
);

if (process.env.NEXT_PUBLIC_ENABLE_MSW === 'true') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { initializeMSW } = require('../msw/setupForNext');
  initializeMSW();
}

const enableConsole = process.env.ENV === 'developement';

const VeejoyApplication = ({ Component, pageProps }) => {
  const { usePlayerV2 } = useNewPlayer();
  useDatadogRum();

  return (
    <ApplicationProviders apolloState={pageProps?.[APOLLO_STATE_PROP_NAME]}>
      <AnnouncementBar />
      <PageHeader />
      {enableConsole && (
        <script
          dangerouslySetInnerHTML={{
            __html: `
        var script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/eruda';
        script.onload = function () {
          eruda.init();
        };
        document.body.appendChild(script);
      `,
          }}
        />
      )}
      {!!pageProps.error && <Error message={pageProps.error} />}
      {!pageProps.error && (
        <>
          <Head>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
          </Head>
          <Component {...pageProps} />
          {usePlayerV2 ? <MediaPlayer2 /> : <MediaPlayer />}
        </>
      )}
    </ApplicationProviders>
  );
};

const __Page_Next_Translate__ = VeejoyApplication;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: true,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  